var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSnsGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "05pofigscc",
    width: "116%",
    height: "120%",
    x: "-8%",
    y: "-8%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "wm83jeix1a",
    cx: 25,
    cy: 25,
    r: 25
  }), /*#__PURE__*/React.createElement("rect", {
    id: "cebekbh97d",
    width: 50,
    height: 50,
    x: 0,
    y: 0,
    rx: 2.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-253 -605) translate(254 606)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "igf0pqylhb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#wm83jeix1a"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25.284,
    stroke: "#CED3DA",
    strokeWidth: 0.568
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#igf0pqylhb)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#05pofigscc)",
    xlinkHref: "#cebekbh97d"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#cebekbh97d"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#igf0pqylhb)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M19.845 10.355c0-.718-.064-1.408-.184-2.07h-9.536V12.2h5.45c-.236 1.265-.949 2.338-2.021 3.056v2.54h3.272c1.914-1.763 3.019-4.358 3.019-7.442z",
    transform: "translate(14.773 14.773)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M10.125 20.25c2.734 0 5.026-.907 6.7-2.453l-3.271-2.54c-.907.607-2.067.966-3.429.966-2.637 0-4.87-1.781-5.665-4.174H1.077v2.623c1.666 3.31 5.09 5.578 9.048 5.578z",
    transform: "translate(14.773 14.773)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC05",
    d: "M4.46 12.049c-.203-.608-.318-1.257-.318-1.924s.115-1.316.318-1.924V5.578H1.077C.39 6.945 0 8.491 0 10.125s.391 3.18 1.077 4.547l3.383-2.623z",
    transform: "translate(14.773 14.773)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M10.125 4.027c1.487 0 2.821.51 3.87 1.514L16.9 2.637C15.146 1.003 12.854 0 10.125 0 6.167 0 2.743 2.269 1.077 5.578L4.46 8.201c.796-2.393 3.028-4.174 5.665-4.174z",
    transform: "translate(14.773 14.773)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnsGoogle);
export default __webpack_public_path__ + "static/media/sns_google.6d935e6a261d7e12062619906802757e.svg";
export { ForwardRef as ReactComponent };